(function () {
  // Mobile drawer
  var drawer = document.querySelector('[data-fh-drawer]');
  var toggle = document.querySelector('[data-fh-menu-toggle]');
  var closers = document.querySelectorAll('[data-fh-menu-close]');
  function openMenu() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.setAttribute('data-fh-menu-open', 'true');
  }
  function closeMenu() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.removeAttribute('data-fh-menu-open');
  }
  if (toggle) toggle.addEventListener('click', openMenu);
  closers.forEach(function (el) { el.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  // Announcement bar rotation
  document.querySelectorAll('[data-fh-announce]').forEach(function (root) {
    var track = root.querySelector('[data-fh-announce-track]');
    if (!track) return;
    var slides = track.children.length;
    if (slides <= 1) return;
    var i = 0;
    var timer = null;
    function go(n) {
      i = (n + slides) % slides;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
    }
    function start() {
      var sec = parseFloat(root.getAttribute('data-autoplay'));
      if (!sec) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, sec * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var prev = root.querySelector('[data-fh-announce-prev]');
    var next = root.querySelector('[data-fh-announce-next]');
    prev && prev.addEventListener('click', function () { go(i - 1); start(); });
    next && next.addEventListener('click', function () { go(i + 1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  // Reviews carousel
  document.querySelectorAll('[data-fh-reviews]').forEach(function (root) {
    var track = root.querySelector('.fh-reviews__track');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track) return;
    var scrollBy = function () {
      var card = track.querySelector('.fh-review');
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -scrollBy(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: scrollBy(), behavior: 'smooth' }); });
  });

  // Bundle selector
  document.querySelectorAll('[data-fh-bundle]').forEach(function (root) {
    var variantInput = root.querySelector('[data-cart-id]');
    var priceEl = root.querySelector('[data-bundle-price]');
    var comparePriceEl = root.querySelector('[data-bundle-compare]');
    var options = root.querySelectorAll('.fh-bundle__option');

    function setActiveSelectsState() {
      options.forEach(function (o) {
        var active = o.getAttribute('data-active') === 'true';
        o.querySelectorAll('.fh-bundle__per-unit-select').forEach(function (s) { s.disabled = !active; });
        // Disable inactive bundles' hidden Camera Color inputs so they don't submit
        o.querySelectorAll('input[data-camera-color]').forEach(function (h) { h.disabled = !active; });
      });
    }

    function moneyFormat(cents) {
      if (!cents && cents !== 0) return '';
      var n = parseInt(cents, 10);
      if (isNaN(n)) return '';
      return '$' + (n / 100).toFixed(2);
    }

    function parseColorMap(str) {
      var map = {};
      if (!str) return map;
      str.split('|').forEach(function (entry) {
        if (!entry) return;
        var name = entry.split('=')[0];
        var rest = entry.substring(name.length + 1);
        var parts = rest.split('&');
        var data = { id: parts[0] || '' };
        for (var i = 1; i < parts.length; i++) {
          var kv = parts[i].split('=');
          data[kv[0]] = kv[1] || '';
        }
        map[name] = data;
      });
      return map;
    }

    function applySwatch(opt, swatch) {
      var cameraNum = swatch.getAttribute('data-camera');
      var color = swatch.getAttribute('data-color');
      var row = swatch.parentElement;
      row.querySelectorAll('.fh-swatch').forEach(function (s) { s.setAttribute('data-active', 'false'); });
      swatch.setAttribute('data-active', 'true');
      var hidden = opt.querySelector('input[data-camera-color="' + cameraNum + '"]');
      if (hidden) hidden.value = color;
      if (row) row.classList.remove('fh-swatches--missing');
      // Camera #1 drives the actual variant
      if (cameraNum === '1') {
        var map = parseColorMap(opt.getAttribute('data-color-variants'));
        var match = map[color];
        if (match && match.id) {
          opt.setAttribute('data-variant', match.id);
          var radio = opt.querySelector('input[type="radio"]');
          if (radio) radio.value = match.id;
          var newPrice = moneyFormat(match.p);
          var newCompare = moneyFormat(match.c);
          if (newPrice) opt.setAttribute('data-price', newPrice);
          opt.setAttribute('data-compare', newCompare || '');
          var pn = opt.querySelector('.fh-bundle__price-now');
          var pw = opt.querySelector('.fh-bundle__price-was');
          if (pn && newPrice) pn.textContent = newPrice;
          if (pw) pw.textContent = newCompare || '';
          if (opt.getAttribute('data-active') === 'true') {
            if (variantInput) variantInput.value = match.id;
            if (priceEl && newPrice) priceEl.textContent = newPrice;
            if (comparePriceEl) comparePriceEl.textContent = newCompare || '';
            // Swap the main gallery image to the variant's featured image
            if (match.img) {
              var imgUrl = decodeURIComponent(match.img);
              var mainImg = document.querySelector('[data-fh-gallery] [data-main-img]');
              if (mainImg && imgUrl) mainImg.setAttribute('src', imgUrl);
              var thumbs = document.querySelectorAll('[data-fh-gallery] [data-thumb]');
              thumbs.forEach(function (t) {
                var full = t.getAttribute('data-full') || '';
                t.classList.toggle('is-active', full.split('?')[0] === imgUrl.split('?')[0]);
              });
            }
          }
        }
      }
    }

    options.forEach(function (opt) {
      opt.querySelectorAll('.fh-swatch').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          applySwatch(opt, sw);
        });
      });
      opt.addEventListener('click', function (e) {
        // don't hijack clicks on the per-unit selects/swatches themselves
        if (e.target.closest('.fh-bundle__per-unit-select')) return;
        if (e.target.closest('.fh-swatch')) return;
        options.forEach(function (o) {
          o.setAttribute('data-active', 'false');
          var r = o.querySelector('input[type="radio"]');
          if (r) r.checked = false;
        });
        opt.setAttribute('data-active', 'true');
        var radio = opt.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        var id = opt.getAttribute('data-variant');
        if (variantInput && id) variantInput.value = id;
        var p = opt.getAttribute('data-price');
        var cp = opt.getAttribute('data-compare');
        if (priceEl && p) priceEl.textContent = p;
        if (comparePriceEl) comparePriceEl.textContent = cp || '';
        setActiveSelectsState();
      });
    });

    setActiveSelectsState();

    root.addEventListener('submit', function (e) {
      var activeOpt = root.querySelector('.fh-bundle__option[data-active="true"]');
      if (!activeOpt) return;
      var missing = [];
      activeOpt.querySelectorAll('input[data-camera-color]').forEach(function (h) {
        if (h.disabled) return;
        if (!h.value) missing.push(h);
      });
      if (missing.length === 0) return;
      e.preventDefault();
      missing.forEach(function (h) {
        var num = h.getAttribute('data-camera-color');
        var rowEl = activeOpt.querySelector('.fh-bundle__swatches[data-camera="' + num + '"]');
        if (rowEl) rowEl.classList.add('fh-swatches--missing');
      });
      var firstNum = missing[0].getAttribute('data-camera-color');
      var firstRow = activeOpt.querySelector('.fh-bundle__swatches[data-camera="' + firstNum + '"]');
      if (firstRow) firstRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  });

  // ===== Slide-out cart drawer =====
  (function () {
    var cart = document.querySelector('[data-fh-cart]');
    if (!cart) return;

    var body = cart.querySelector('[data-fh-cart-body]');
    var foot = cart.querySelector('[data-fh-cart-foot]');
    var emptyEl = cart.querySelector('[data-fh-cart-empty]');
    var subtotalEl = cart.querySelector('[data-fh-cart-subtotal]');
    var savingsEl = cart.querySelector('[data-fh-cart-savings]');
    var countLabel = cart.querySelector('[data-fh-cart-count-label]');
    var shipWrap = cart.querySelector('[data-fh-ship]');
    var shipMsg = cart.querySelector('[data-fh-ship-msg]');
    var shipFill = cart.querySelector('[data-fh-ship-fill]');
    var threshold = parseInt(cart.getAttribute('data-threshold'), 10) || 0;
    var moneyFormat = cart.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      cents = parseInt(cents, 10) || 0;
      var value = (cents / 100);
      var format = moneyFormat;
      function withCommas(num, decimals, thousands, decimalSep) {
        var fixed = num.toFixed(decimals);
        var parts = fixed.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimalSep);
      }
      var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = match ? match[1] : 'amount';
      var out;
      switch (placeholder) {
        case 'amount_no_decimals': out = withCommas(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = withCommas(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = withCommas(value, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': out = withCommas(value, 2, "'", '.'); break;
        default: out = withCommas(value, 2, ',', '.');
      }
      return format.replace(/\{\{\s*\w+\s*\}\}/, out);
    }

    function setCount(n) {
      document.querySelectorAll('[data-fh-cart-count]').forEach(function (el) {
        el.textContent = n;
        if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
      });
      if (countLabel) countLabel.textContent = n > 0 ? '(' + n + ')' : '';
    }

    function open() {
      cart.setAttribute('data-open', 'true');
      cart.setAttribute('aria-hidden', 'false');
      document.body.setAttribute('data-fh-cart-open', 'true');
    }
    function close() {
      cart.setAttribute('data-open', 'false');
      cart.setAttribute('aria-hidden', 'true');
      document.body.removeAttribute('data-fh-cart-open');
    }

    function renderShip(total) {
      if (!shipWrap || threshold <= 0) return;
      if (total >= threshold) {
        shipMsg.innerHTML = '🎉 You’ve unlocked <b>FREE shipping!</b>';
        shipFill.style.width = '100%';
      } else {
        var remaining = threshold - total;
        shipMsg.innerHTML = 'You’re <b>' + formatMoney(remaining) + '</b> away from free shipping';
        shipFill.style.width = Math.min(100, (total / threshold) * 100) + '%';
      }
    }

    function lineRow(item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var colorSlug = variant ? variant.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
      var dot = variant ? '<span class="fh-cart__dot fh-swatch--' + colorSlug + '" aria-hidden="true"></span>' : '';
      var props = '';
      if (item.properties) {
        for (var k in item.properties) {
          if (item.properties.hasOwnProperty(k) && item.properties[k] && k.charAt(0) !== '_') {
            props += '<span class="fh-cart__prop">' + k + ': ' + item.properties[k] + '</span>';
          }
        }
      }
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';

      // Discounted price display (struck original + final) and a deal tag
      var discounted = item.original_line_price > item.final_line_price;
      var priceHtml = discounted
        ? '<s class="fh-cart__price-was">' + formatMoney(item.original_line_price) + '</s><span class="fh-cart__price-now">' + formatMoney(item.final_line_price) + '</span>'
        : formatMoney(item.final_line_price);
      var dealTag = '';
      var allocs = item.line_level_discount_allocations || [];
      if (allocs.length) {
        var da = allocs[0];
        var title = (da.discount_application && da.discount_application.title) ? da.discount_application.title : 'Bundle deal';
        dealTag = '<span class="fh-cart__deal">🎁 ' + title + ' · saved ' + formatMoney(da.amount) + '</span>';
      }

      return '' +
        '<div class="fh-cart__item" data-key="' + item.key + '">' +
          '<div class="fh-cart__item-img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="fh-cart__item-info">' +
            '<div class="fh-cart__item-title">' + item.product_title + '</div>' +
            (variant ? '<div class="fh-cart__item-variant">' + dot + variant + '</div>' : '') +
            props +
            dealTag +
            '<div class="fh-cart__item-controls">' +
              '<div class="fh-cart__qty">' +
                '<button type="button" data-fh-qty-dec aria-label="Decrease quantity">−</button>' +
                '<span data-fh-qty>' + item.quantity + '</span>' +
                '<button type="button" data-fh-qty-inc aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="fh-cart__remove" data-fh-remove aria-label="Remove">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="fh-cart__item-price">' + priceHtml + '</div>' +
        '</div>';
    }

    function render(data) {
      // Lets other scripts react to every basket update (e.g. the Dreamlet Stories box).
      document.dispatchEvent(new CustomEvent('fh:cart', { detail: data }));
      setCount(data.item_count);
      if (data.item_count === 0) {
        body.innerHTML = '';
        body.setAttribute('hidden', '');
        if (foot) foot.setAttribute('hidden', '');
        if (shipWrap) shipWrap.setAttribute('hidden', '');
        if (emptyEl) emptyEl.removeAttribute('hidden');
        return;
      }
      if (emptyEl) emptyEl.setAttribute('hidden', '');
      body.removeAttribute('hidden');
      if (foot) foot.removeAttribute('hidden');
      if (shipWrap) shipWrap.removeAttribute('hidden');
      body.innerHTML = data.items.map(lineRow).join('');
      if (subtotalEl) subtotalEl.textContent = formatMoney(data.total_price);
      if (savingsEl) {
        if (data.total_discount && data.total_discount > 0) {
          savingsEl.innerHTML = '🎉 You’re saving <b>' + formatMoney(data.total_discount) + '</b> with your bundle';
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
      renderShip(data.total_price);
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { render(data); return data; });
    }

    function changeLine(key, quantity) {
      body.classList.add('is-busy');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); })
        .then(function (data) { render(data); body.classList.remove('is-busy'); return data; })
        .catch(function () { body.classList.remove('is-busy'); });
    }

    body.addEventListener('click', function (e) {
      var row = e.target.closest('.fh-cart__item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtyEl = row.querySelector('[data-fh-qty]');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      if (e.target.closest('[data-fh-qty-inc]')) changeLine(key, qty + 1);
      else if (e.target.closest('[data-fh-qty-dec]')) changeLine(key, Math.max(0, qty - 1));
      else if (e.target.closest('[data-fh-remove]')) changeLine(key, 0);
    });

    document.querySelectorAll('[data-fh-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); open(); refresh(); });
    });
    cart.querySelectorAll('[data-fh-cart-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // Public API for the PDP add-to-cart
    window.FHCart = { open: function () { open(); refresh(); }, refresh: refresh, close: close };

    // Initial count sync (in case server-rendered count drifted)
    refresh();
  })();

  // PDP thumbnail gallery
  document.querySelectorAll('[data-fh-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-main-img]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-full');
        if (main && src) main.setAttribute('src', src);
      });
    });
    // Mobile swipe on the main image
    if (main && thumbs.length > 1) {
      var currentIndex = function () {
        var idx = 0;
        thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) idx = i; });
        return idx;
      };
      var goTo = function (i) {
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        var t = thumbs[i];
        if (!t) return;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        var src = t.getAttribute('data-full');
        if (src) main.setAttribute('src', src);
        t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      };
      var sx = 0, sy = 0, swiping = false;
      var target = main.parentElement || main;
      target.addEventListener('touchstart', function (e) {
        var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
      }, { passive: true });
      target.addEventListener('touchend', function (e) {
        if (!swiping) return; swiping = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(dx < 0 ? currentIndex() + 1 : currentIndex() - 1);
        }
      }, { passive: true });
    }

    // Thumb strip arrows
    var strip = root.querySelector('[data-fh-thumbs]');
    var prevBtn = root.querySelector('[data-thumb-prev]');
    var nextBtn = root.querySelector('[data-thumb-next]');
    if (strip && prevBtn && nextBtn) {
      var step = function () {
        var firstThumb = strip.querySelector('.fh-pdp__thumb');
        var w = firstThumb ? firstThumb.getBoundingClientRect().width + 6 : 80;
        return w * 3;
      };
      prevBtn.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      nextBtn.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
      var updateArrowState = function () {
        prevBtn.disabled = strip.scrollLeft <= 2;
        nextBtn.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      strip.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }
  });
})();
